import { useWindowDimensions } from 'react-native';
import { IOverlayWithHoles } from './Tutorial.types';
import Svg, { Defs, Mask, Rect } from 'react-native-svg';

export const OverlayWithHoles = ({ holes, opacity, color }: IOverlayWithHoles) => {
  const { width, height } = useWindowDimensions();
  const screenWidth = width;
  const screenHeight = height;

  if (holes.length === 0) {
    return (
      <Svg
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          pointerEvents: 'none',
        }}
        width={screenWidth}
        height={screenHeight}
      >
        <Rect x="0" y="0" width={screenWidth} height={screenHeight} fill={color} opacity={opacity} />
      </Svg>
    );
  }

  return (
    <Svg
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        pointerEvents: 'none',
      }}
      width={screenWidth}
      height={screenHeight}
    >
      <Defs>
        <Mask id="mask" x="0" y="0" width={screenWidth} height={screenHeight}>
          <Rect x="0" y="0" width={screenWidth} height={screenHeight} fill="white" />
          {holes.map((hole, index) => {
            const { x = 0, y = 0, width = 100, height = 100, borderRadius = 0 } = hole;

            return (
              <Rect
                key={`hole-${index}`}
                x={x}
                y={y}
                width={width}
                height={height}
                rx={borderRadius}
                ry={borderRadius}
                fill="black"
              />
            );
          })}
        </Mask>
      </Defs>
      <Rect x="0" y="0" width={screenWidth} height={screenHeight} fill={color} opacity={opacity} mask="url(#mask)" />
    </Svg>
  );
};
